import React from 'react'
import { action, observable } from 'mobx'
import { RESIZE } from '../../utils/dom/dom-events'
import { config } from '../../config/config'

export const DEFAULT_SCREEN_WIDTH = 1024
export const DEFAULT_SCREEN_HEIGHT = 768

export class AppStore {
    @observable
    screenWidth = DEFAULT_SCREEN_WIDTH

    @observable
    screenHeight = DEFAULT_SCREEN_HEIGHT

    @observable
    devTools

    @observable
    loading = false

    constructor() {
        window.addEventListener(RESIZE, this.resizeHandler)

        this.resizeHandler()
    }

    @action
    setDevTools = () => {
        if (!config.isProduction) {
            try {
                import('mobx-react-devtools').then(({ default: DevTools }) => {
                    this.devTools = React.createElement(
                        DevTools,
                        {
                            position: {
                                right: 24,
                                bottom: 0
                            }
                        }
                    )
                })
            } catch (error) {
                this.devTools = null
            }
        } else {
            this.devTools = null
        }
    }

    @action
    loadingStart = () => {
        if (this.loading) return
        this.loading = true
    }

    @action
    loadingStop = () => {
        if (!this.loading) return
        this.loading = false
    }

    resizeHandler = () => {
        this.screenWidth = window.innerWidth
        this.screenHeight = window.innerHeight
    }
}
